import api from './api';

export interface ChatMessage {
  id?: string;
  message: string;
  response?: string;
  timestamp?: string;
}

export interface ChatHistory {
  id: number;
  user_message: string;
  bot_response: string;
  created_at: string;
}

export const chatbotService = {
  sendMessage: async (message: string): Promise<{ response: string; status: string }> => {
    const response = await api.post('/chatbot/chat/', { message });
    return response.data;
  },

  getHistory: async (): Promise<ChatHistory[]> => {
    const response = await api.get('/chatbot/history/');
    return response.data;
  },
};
